
import { Component, Vue } from 'vue-property-decorator'
import PromotionCodeList from '@/components/promotion-code/PromotionCodeList.vue'

@Component({
  name: 'PromotionCodes',
  components: { PromotionCodeList }
})
class PromotionCodes extends Vue {}

export default PromotionCodes
